import styled from "styled-components";
import { Modal } from "react-bootstrap";

export const MobileModal = styled(Modal)`
  @media (max-width: 768px) {
    .modal-content {
      border: none;
      border-radius: 0;
      height: 100vh;
    }
    .modal-header {
      border: none;
    }
    .modal-dialog {
      margin: 0;
    }
    max-width: none !important;
    border: none;
    height: 100vh;
    margin: 0 !important;
  }
`;

export const SiteUrlWrapper = styled.div`
  display: flex;
  height: 3rem;
  @media (max-width: 768px) {
    flex-direction: column;
    height: 7rem;
  }
`;
export const SiteUrlTextWrapper = styled.div`
  flex: 1.5;
  margin-right: 20px;
  @media (min-width: 769px) {
    width: 490px;
  }
  @media (max-width: 768px) {
    width: 100%;
    margin: 0;
  }
  input {
    &:hover {
      cursor: not-allowed;
    }
    &:focus {
      outline: none;
    }
  }
`;

export const ActionsWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-width: 768px) {
    justify-content: flex-start;
    margin-top: 1rem;
    flex-direction: row;
    height: 50.4px;
    margin-left: -0.5rem;
  }
`;

export const PreviewLinkLabel = styled.div`
  width: 100%;
  font-family: "Open Sans", sans-serif;
`;
export const SiteNameLabel = styled.label`
  font-family: "Open Sans", sans-serif;
  font-size: 0.9rem;
  color: #000;
  margin-right: 1%;
`;
